module.exports = __webpack_public_path__ + "img/cloth_g3_item_17.adf46dd0.svg";